import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "back-soon__text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "back-soon__figure" }, null, -1)

import { useI18n } from 'vue-i18n';
import FallbackPage from '@/components/FallbackPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FallbackPage, {
    title: _unref(t)('alerts.temporaryUnavailable'),
    titleSize: "medium",
    imagePosition: "background",
    class: "back-soon"
  }, {
    text: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("alerts.temporaryUnavailableText")), 1)
    ]),
    image: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})